import React from 'react'
import { Row, Col } from 'react-flexbox-grid'
import { Form, Number } from 'components/forms'
import { ContentBlock } from 'components/ContentBlock'
import { useTranslation } from 'react-i18next'

const Options = ({ data, formData, mutations: { updateItem } }) => {
	const [t] = useTranslation()
	return(
		<ContentBlock>
			<Form
				smartSubmit
				initialValues={formData}
				onSubmit={updateItem}
				render={() => (
					<Row>
						<Col xs>
							<Number
								withControls={false}
								precision={2}
								label={t('category_section.fields.surcharge_from')}
								placeholder={t('category_section.placeholders.surcharge_from')}
								multiField={5}
								field='surchargeFrom'
							/>
						</Col>
						<Col xs>
							<Number
								withControls={false}
								precision={2}
								label={t('category_section.fields.surcharge_amount')}
								placeholder={t('category_section.placeholders.surcharge_amount')}
								multiField={5}
								field='surchargeAmount'
							/>
						</Col>
						<Col xs>
							<Number
								withControls={false}
								precision={2}
								label={t('category_section.fields.surcharge_percent')}
								placeholder={t('category_section.placeholders.surcharge_percent')}
								multiField={5}
								field='surchargePercent'
							/>
						</Col>
					</Row>
				)}/>
		</ContentBlock>
	)
}

export default Options
